// import {toolbarOptions} from './ToolbarOptions'
import {constantClasses} from './ConstantClasses'
// import {families} from './Families'
import {menu} from './Menu'

export default {
    constantClasses,
    menu,
    // toolbarOptions,
    // families,
}